module.exports = __webpack_public_path__ + "static/img/ted.647e555a.png";